<template>
  <div>
    <div class="media-list">
      <el-row type="flex" align="bottom">
        <el-col :span="22">
          <div class="breadcrumb-bar">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item :to="{ path: '/contentSection' }"
                >内容专区运营</el-breadcrumb-item
              >
              <el-breadcrumb-item>分享记录</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="tableList">
      <el-form :inline="true" :model="formContent" class="searchForm">
        <el-form-item label="分享版块">
          <el-input v-model.trim="formContent.name"></el-input>
        </el-form-item>

        <el-form-item label="邀请码类型" label-width="120px">
          <el-select v-model="formContent.type" placeholder="请选择" clearable>
            <el-option
              v-for="item in typeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="兑换码">
          <el-input v-model.trim="formContent.couponSN"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onQuery" icon="el-icon-search"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
      <div class="btnRight" style="text-align: right; margin-bottom: 20px">
        <el-button type="primary" icon="plus" @click="importEquity"
          >导入权益</el-button
        >
      </div>
      <Card>
        <div class="panel-box">
          <h3 class="panel-title">分享记录</h3>
          <div class="tableToList">
            <el-table
              ref="multipleTable"
              :header-cell-style="rowClass"
              :data="queryData"
              style="width: 100%"
              @selection-change="handleSelectionChange"
            >
              <el-table-column
                prop="createdAt"
                label="分享版块"
                align="center"
                min-width="150"
              >
                <template slot-scope="scope">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    v-for="(item, index) in scope.row.goodsInfo"
                    placement="top-start"
                    :key="index"
                  >
                    <span
                      slot="content"
                      v-for="(item2, index) in scope.row.goodsInfo"
                      :key="index"
                    >
                      {{ item2.sectionName }}
                    </span>
                    <p v-show="index < 2">
                      {{ item.sectionName }}
                    </p>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                prop="createdAt"
                label="生成时间"
                align="center"
                min-width="150"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.createdAt | formatDate2 }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="name"
                label="邀请码类型"
                align="center"
                width="120"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.type == 1">邀请码</span>
                  <span v-if="scope.row.type == 2">专享码</span>
                </template></el-table-column
              >

              <el-table-column
                prop="lable"
                label="使用期限"
                align="center"
                min-width="150"
              >
                <template slot-scope="scope">
                  <span v-if="!scope.row.isSecDeleted"
                    >{{ scope.row.startTime | formatDate3 }} ——
                    {{ scope.row.endTime | formatDate3 }}</span
                  >
                  <span v-else>无</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="remark"
                label="备注"
                align="center"
                min-width="100"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="usedCnt"
                label="领取人数"
                align="center"
                min-width="100"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row | getUsedCnt }}</span>
                </template></el-table-column
              >
              <el-table-column
                prop="categoryId"
                label="操作"
                align="center"
                width="180"
              >
                <template slot-scope="scope">
                  <el-tooltip content="编辑" placement="top">
                    <el-button
                      v-if="
                        scope.row.name != '批量导入' && !scope.row.isSecDeleted
                      "
                      type="primary"
                      size="mini"
                      icon="el-icon-edit"
                      @click="handleEdit(scope.row)"
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip content="详情" placement="top">
                    <el-button
                      type="info"
                      size="mini"
                      icon="el-icon-document"
                      style="background-color: #009e7d"
                      @click="handleInvitationDetail(scope.row)"
                    ></el-button>
                  </el-tooltip> </template
              ></el-table-column>
            </el-table>
          </div>
        </div>
      </Card>
      <div class="pagination-box" style="padding: 30px 0px 30px 0px !important">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryParams.page"
          :page-sizes="[20, 50, 100]"
          :page-size="queryParams.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal"
        ></el-pagination>
      </div>
    </div>

    <!-- <div style="display: flex; justify-content: center">
      <el-button @click="cencel">取消</el-button>
      <el-button
        type="primary"
        style="background-color: #009e7d"
        @click="confirmSubmit"
        >确定</el-button
      >
    </div> -->
    <el-dialog
      title="导入权益样式"
      :visible.sync="centerDialogVisible"
      width="45%"
      center
      class="preShare"
    >
      <el-table
        ref="multipleTable"
        :header-cell-style="rowClass"
        :data="templateList"
        style="width: 60%"
        border
      >
        <el-table-column
          prop="name"
          label="分享版块名称"
          align="center"
          min-width="150"
        >
        </el-table-column>

        <el-table-column
          prop="phone"
          label="手机号"
          align="center"
          min-width="150"
        >
        </el-table-column>
      </el-table>
      <p style="margin-top: 20px">功能说明</p>
      <p>1，手机号兑换表格内填写的版块</p>
      <p>2，多个版块可填写同一手机号，将关联多个版块内容生成权益</p>
      <p>
        3，同一手机号仅能在表格里导入一次生产的兑换码生效，多次导入重复的手机号会去筛除
      </p>
      <p>
        4，用户在设备兑换时，输入品牌代称字母+手机号后7位即可兑换（可在兑换记录里查询）
      </p>
      <p>5，品牌代称字母，联系开放平台工作人员获得</p>
      <p>6，仅支持.excel文件导入</p>
      <el-upload
        action="/edu/eduAdmin/hxd/batch_import_right"
        accept=".xlsx, .xls"
        :before-upload="onBeforeUpload"
        :on-success="onSuccessUpload"
        :on-error="onErrorUpload"
        :data="uploadData"
        :show-file-list="true"
        style="margin-top: 20px"
      >
        <el-button size="small" type="primary">
          立即导入
          <i class="el-icon-upload el-icon--right"></i>
        </el-button>
      </el-upload>
    </el-dialog>
    <el-dialog
      title="编辑运营内容"
      :visible.sync="dialogVisible"
      width="60%"
      center
    >
      <el-form :model="formInvitation" label-width="125px">
        <el-form-item label="*邀请码类型">
          <el-input
            v-model="formInvitation.code"
            disabled
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item :label="formInvitation.valueTo == 1 ? '人数' : '*SN数量'">
          <el-select
            v-model="formInvitation.peopleNumTo"
            placeholder="请选择"
            v-if="formInvitation.valueTo == 1"
          >
            <el-option
              v-for="item in peopleNum"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="formInvitation.peopleNumToSelf"
            placeholder="请选择"
            v-if="formInvitation.valueTo != 1"
          >
            <el-option
              v-for="item in peopleNumSelf"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="formInvitation.valueTo == 1 ? '使用时限' : '*兑换时限'"
        >
          <el-date-picker
            v-model="formInvitation.startTime"
            type="date"
            format="yyyy-MM-dd"
            style="width: 180px; font-size: 10px"
          ></el-date-picker>
          至
          <el-date-picker
            v-model="formInvitation.endTime"
            type="date"
            format="yyyy-MM-dd"
            style="width: 180px; font-size: 10px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="formInvitation.remark"
            type="textarea"
            :rows="3"
            style="width: 50%"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-button
        @click="editInvitation"
        style="background-color: #009e7d; color: #ffffff; margin-bottom: 20px"
      >
        {{ formInvitation.valueTo == 1 ? "编辑邀请码" : "编辑专享码" }}
      </el-button>
      <span
        slot="footer"
        class="dialog-footer"
        style="float: right; margin-top: -40px"
      >
        <el-button @click="dialogVisible = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { ApiMessage, formatDate } from "@/utils/util";
import moment from "moment";
export default {
  data() {
    return {
      formContent: {
        name: "",
        type: "",
        couponSN: "",
      },
      paltaId: "", //当前分享邀请码（专享码）的id
      queryData: [],
      templateList: [{ name: "牛津树", phone: "13811111111" }],
      type: [],
      onetargetId: "",
      typeList: [
        { value: 1, label: "邀请码" },
        { value: 2, label: "专享码" },
      ],
      queryParams: {
        page: 1,
        pageSize: 20,
      },
      pageTotal: 0,
      nameList: [],
      uploadData: {
        appId: "",
        filename: "",
      },
      centerDialogVisible: false,
      dialogVisible: false,
      formPlan: {},
      formInvitation: {
        remark: "",
      },
      InvitationCode: [
        { value: 1, label: "邀请码" },
        { value: 2, label: "专享码" },
      ],
      peopleNum: [
        { value: 0, label: "不限" },
        { value: 500, label: "500人" },
        { value: 200, label: "200人" },
        { value: 100, label: "100人" },
      ],
      peopleNumSelf: [
        { value: 500, label: "500人" },
        { value: 200, label: "200人" },
        { value: 100, label: "100人" },
      ],
    };
  },

  filters: {
    formatDate2(d) {
      return formatDate(d, "yyyy-MM-dd hh:mm:ss");
    },
    formatDate3(d) {
      return formatDate(d, "yyyy-MM-dd");
    },
    getUsedCnt(row) {
      if (row.personLimit == 0) {
        return `${row.usedCnt}/${"不限"}`;
      } else {
        return `${row.usedCnt}/${row.personLimit}`;
      }
    },
  },
  async created() {
    // await this.saveContentSection();
    this.saveinviteCode();
  },
  methods: {
    rowClass() {
      return "background:#f9f9f9;color:#000000;font-size:14px;height:22px";
    },
    formatter(row, cloum) {
      console.log(row, cloum);
      let goodsArr = row.goodsInfo;
      let newArr = [];
      if (goodsArr.length > 2) {
        for (let i = 0; i <= 2; i++) {
          newArr.push(goodsArr[i]);
        }
      }
    },

    onBeforeUpload(file) {
      this.uploadData.appId = this.$API.APPID;
      this.uploadData.filename = file.name;
    },
    onSuccessUpload(response, file, fileList) {
      if (response.rc == 0) {
        this.$message.success("导入成功");
        this.uploadResult = response.data;
        // console.log(this.badResult)
        this.saveinviteCode();
      } else {
        alert(response.err);
      }
    },
    onErrorUpload(err, file, fileList) {
      alert(err);
    },
    onQuery() {
      // console.log(this.formContent);
      this.queryParams.page = 1;
      this.saveinviteCode();
    },
    saveContentSection() {
      return new Promise((resolve, reject) => {
        let params = {
          appId: this.$API.APPID,
        };
        this.$axios
          .post("/edu/eduAdmin/contentzone/detail", params)
          .then((response) => {
            if (response.data.rc == "0") {
              let _data = response.data.data;
              this.formContent.name = _data.name;
              this.formContent.imgUrl = _data.icon;
              this.ids = _data.id;
              this.onetargetId = _data.targetId;
              console.log(_data, "saveContentSection====");
              resolve();
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject();
          });
      });
    },
    confirmSubmit() {
      this.cencel();
    },
    cencel() {
      this.$router.push({
        path: "/contentSection",
      });
    },
    handleSelectionChange() {},
    handleEdit(row) {
      this.formPlan = JSON.parse(JSON.stringify(row));
      console.log(row);
      this.formInvitation.valueTo = row.type;
      this.paltaId = row.id;
      this.$set(this.formInvitation, "remark", row.remark);
      this.$set(this.formInvitation, "peopleNumTo", row.personLimit);
      this.$set(this.formInvitation, "peopleNumToSelf", row.personLimit);
      this.$set(
        this.formInvitation,
        "startTime",
        formatDate(row.startTime, "yyyy-MM-dd")
      );
      this.$set(
        this.formInvitation,
        "endTime",
        formatDate(row.endTime, "yyyy-MM-dd")
      );

      if (row.type == 1) {
        this.formInvitation.code = "邀请码";
      } else if (row.type == 2) {
        this.formInvitation.code = "专享码";
      }

      this.dialogVisible = true;
    },
    editInvitation() {
      console.log(this.formInvitation, this.formPlan);
      if (
        this.formInvitation.startTime == null ||
        this.formInvitation.endTime == null
      ) {
        alert("时限开始时间或结束时间不能为空");
        return;
      }
      let getStartTime = moment(this.formInvitation.startTime).unix();
      let getEndTime =
        moment(this.formInvitation.endTime).unix() + (24 * 60 * 60 - 1);
      let nowTime = moment(
        formatDate(new Date().valueOf(), "yyyy-MM-dd")
      ).unix();
      let params = {
        appId: this.$API.APPID,
        inviteId: String(this.paltaId),
        type: this.formInvitation.valueTo,
        remark: this.formInvitation.remark,
      };
      if (this.formInvitation.valueTo == 1) {
        // 邀请码
        if (
          this.formInvitation.peopleNumTo &&
          this.formInvitation.peopleNumTo < this.formPlan.getCnt
        ) {
          alert("邀请码数量不能小于已生成的数量");
          return;
        }
        params.personLimit = this.formInvitation.peopleNumTo;
      } else if (this.formInvitation.valueTo == 2) {
        // 专享码
        if (this.formInvitation.peopleNumToSelf < this.formPlan.getCnt) {
          alert("专享码SN数量不能小于修改前的SN数量");
          return;
        }
        params.personLimit = this.formInvitation.peopleNumToSelf;
      }
      if (getStartTime > getEndTime) {
        alert("使用期限开始日期不能大于结束日期");
        return;
      }
      if (nowTime > getEndTime) {
        alert("使用期限结束日期不能小于当前日期");
        return;
      }
      params.startTime = getStartTime;
      params.endTime = getEndTime;
      this.$axios
        .post("/edu/eduAdmin/hxd/invite_code_save", params)
        .then((response) => {
          if (response.data.rc == "0") {
            this.$message.success("编辑成功");
            this.dialogVisible = false;
            this.saveinviteCode();
          } else {
            alert(response.data.err);
          }
        });
    },
    handleInvitationDetail(row) {
      const routeData = this.$router.resolve({
        path: "/invitationDetail",
        query: row,
      });
      window.open(routeData.href, "_blank");
    },
    // 列表
    saveinviteCode() {
      let params = {
        appId: this.$API.APPID,
      };
      if (this.formContent.name !== "") {
        params.sectionName = this.formContent.name;
      }
      if (this.formContent.type !== "") {
        params.shareType = Number(this.formContent.type);
      }
      if (this.formContent.couponSN !== "") {
        params.couponSN = this.formContent.couponSN;
      }
      params.pageSize = this.queryParams.pageSize;
      params.page = this.queryParams.page;
      this.$axios
        .post("/edu/eduAdmin/hxd/invite_code_list", params)
        .then((response) => {
          console.log(response);
          if (response.data.rc == "0") {
            console.log(response.data.data);
            this.queryData = response.data.data.list;

            this.pageTotal = response.data.data.pager.total;
          } else {
            alert(response.data.err);
          }
        });
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.saveinviteCode();
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.saveinviteCode();
    },
    importEquity() {
      this.centerDialogVisible = true;
    },
    eduAxiosPostRequest(address, params) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post(address, params)
          .then((response) => {
            console.log(response);
            if (response.data.rc == "0") {
              if (
                address.indexOf("package_del") != -1 ||
                address.indexOf("package_batch") != -1
              ) {
                resolve(JSON.stringify(response.data.msg));
              } else {
                resolve(JSON.stringify(response.data.data));
              }
            } else {
              alert(response.data.rc + ". " + response.data.err);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
  },
};
</script>

<style lang="less" >
@import "../fyd-style";
@import "../commonEdu";
.preShare .el-dialog__headerbtn {
  font-size: 20px;
}

.preShare .el-icon-close {
  color: #ffff;
}
</style>


// WEBPACK FOOTER //
// prefectureShare.vue?ca03491a